// Navigation de l'application (pas de routeur) : on pousse l'URL et App relit le chemin.
export function naviguer(chemin) {
  window.history.pushState({}, '', chemin);
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.scrollTo(0, 0);
}
